import React from 'react';
import PropTypes from 'prop-types';

import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';

import {
  Heading,
  Panel,
  PlaybackList,
  PlaybackKey,
  PlaybackValue,
} from '@piggybank/core';

import { formatAccountWithMaskChar, formatAmount, formatAmountByValue, formatDateObj, formatTimeObj } from '~/genericFunctions';
import { getDiHeaderKey, NLS } from '~/pages/SuccessPage/successPageFunctions';

import { withAppContext } from '~/AppContext';

const DiSuccessCreditInformationPanel = ({ data }) => {
  let folio = get(data, 'displayData.folio');
  let index = get(data, 'displayData.loanAmountIndex');
  let loanOptions = get(data, 'displayData.loanOffer.loanOptions');
  let depositAccount = get(data, 'displayData.loanOffer.depositAccount');
  let currDateTime = new Date(Date.now());
  const principalAmount = isEmpty(loanOptions)? 0: get(loanOptions[index], 'principal.amount');

  return (
    <Panel>
      <Heading level={2}>
        {NLS`${getDiHeaderKey(data.displayData.globalData.offerId)}`}
      </Heading>
      <PlaybackList type="strong">
        <PlaybackKey>{NLS`Loan amount`}</PlaybackKey>
        <PlaybackValue>{formatAmountByValue(principalAmount)}</PlaybackValue>

        <PlaybackKey>{NLS`Deposit account`}</PlaybackKey>
        <PlaybackValue>{formatAccountWithMaskChar(get(depositAccount, 'number'), '*')}</PlaybackValue>

        <PlaybackKey>{NLS`Commission fee`}</PlaybackKey>
        <PlaybackValue>{formatAmount(loanOptions, index, 'fees.commission.amount')}</PlaybackValue>

        <PlaybackKey>{NLS`Value added tax`}</PlaybackKey>
        <PlaybackValue>{formatAmount(loanOptions, index, 'fees.valueAddedTax.amount')}</PlaybackValue>

        <PlaybackKey>{NLS`Folio`}</PlaybackKey>
        <PlaybackValue>{folio}</PlaybackValue>

        <PlaybackKey>{NLS`Date`}</PlaybackKey>
        <PlaybackValue>{formatDateObj(currDateTime)}</PlaybackValue>

        <PlaybackKey>{NLS`Time`}</PlaybackKey>
        <PlaybackValue marginBottom={0}>{formatTimeObj(currDateTime)}</PlaybackValue>
      </PlaybackList>
    </Panel>
  );
};

DiSuccessCreditInformationPanel.propTypes = {
  data: PropTypes.shape({
    displayData: PropTypes.shape({
      loanOffer: PropTypes.shape({
        depositAccount: PropTypes.shape({
          number: PropTypes.string,
        }),
        loanOptions: PropTypes.arrayOf(PropTypes.shape()),
      }),
      folio: PropTypes.string,
      loanAmountIndex: PropTypes.number,
    }),
  }),
};

export default withAppContext()(DiSuccessCreditInformationPanel);
